import type { IWidget } from '@/interfaces/components/dashboard/widget'
import { useCompanyDashboardStore } from '@/store/companyDashboard'
import { resolveWidgetUnit } from '@/utils/sensor-schema-fields'
import {
  formatWidgetMetricValue,
  isDurationMinutesField,
  resolveWidgetDisplayUnit,
} from '@/utils/dashboard/format-widget-metric'
import { storeToRefs } from 'pinia'

export const INDICATOR_ACCENT_COLOR = '#123add'

export function useIndicatorWidget() {
  const store = useCompanyDashboardStore()
  const { widgetData } = storeToRefs(store)

  const getValue = (widget: IWidget): string => {
    const state = widgetData.value[widget.id]
    if (!state || state.loading) return '...'
    if (state.error || state.value === null) return '--'

    const dataField = widget.config.data_field
    if (isDurationMinutesField(dataField)) {
      return formatWidgetMetricValue(state.value, dataField ?? '')
    }

    return state.value.toFixed(1)
  }

  const getUnit = (widget: IWidget): string => {
    const state = widgetData.value[widget.id]
    const unit = resolveWidgetUnit(widget, state?.unit ?? '')
    return resolveWidgetDisplayUnit(widget.config.data_field, unit)
  }

  const isLoading = (widget: IWidget): boolean => {
    return widgetData.value[widget.id]?.loading ?? false
  }

  const hasError = (widget: IWidget): boolean => {
    return widgetData.value[widget.id]?.error ?? false
  }

  return {
    getValue,
    getUnit,
    isLoading,
    hasError,
    ACCENT_COLOR: INDICATOR_ACCENT_COLOR,
  }
}
